import React from 'react';
import CommonModal from './Modal';
import _ from 'lodash';

const ConfirmAppEnd = props => {
  const {
    visible = false,
    title = '',
    message = '',
    confirmButtonText = '利用を終了する',
    cancelButtonText = '戻る',
    isNegative = false,
    onConfirm,
    onCancel,
    isSubmitting = false,
    disabledConfirmButton = false,
    rootClassName,
    negativeButtonClassName = 'btn--negative',
    effectiveButtonClassName = 'btn--effective',
    cancelButtonClassName = 'btn--sub',
    isVerticalButton = false,
    multilineText = false, // 通常のダイアログは左寄せ(true)
  } = props;

  return (
    <React.Fragment>
      {visible && (
        <CommonModal visible={visible}>
          <div
            className={
              rootClassName
                ? `${rootClassName} confirm-app-end-modal dialog-md dialog--modal`
                : 'dialog-md dialog--modal'
            }
            style={{ width: '450px', maxWidth: '450px' }}
          >
            {title !== '' && (
              <div className='dialog-md__header'>
                <span
                  className='dialog-md__title'
                  data-testid='confirmation_title'
                >
                  {title}
                </span>
              </div>
            )}
            {message !== '' && (
              <div
                className={
                  multilineText
                    ? 'dialog-md__body dialog-md__body-prewrap text-left'
                    : 'dialog-md__body text-left'
                }
                data-testid='confirmation_body'
              >
                {message}
              </div>
            )}
            <div
              className={
                isVerticalButton
                  ? 'dialog-md__footer'
                  : 'dialog-md__footer-horizontal'
              }
            >
              {isNegative ? (
                <React.Fragment>
                  <button
                    className={cancelButtonClassName}
                    onClick={onCancel ? onCancel : undefined}
                    disabled={isSubmitting ? 'disabled' : ''}
                  >
                    {cancelButtonText}
                  </button>
                  <button
                    className={negativeButtonClassName}
                    onClick={onConfirm ? onConfirm : undefined}
                    disabled={
                      isSubmitting || disabledConfirmButton ? 'disabled' : ''
                    }
                  >
                    {confirmButtonText}
                  </button>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <button
                    className={cancelButtonClassName}
                    onClick={onCancel ? onCancel : undefined}
                    disabled={isSubmitting ? 'disabled' : ''}
                  >
                    {cancelButtonText}
                  </button>
                  <button
                    className={effectiveButtonClassName}
                    onClick={onConfirm ? onConfirm : undefined}
                    disabled={
                      isSubmitting || disabledConfirmButton ? 'disabled' : ''
                    }
                  >
                    {confirmButtonText}
                  </button>
                </React.Fragment>
              )}
            </div>
          </div>
        </CommonModal>
      )}
    </React.Fragment>
  );
};

export default ConfirmAppEnd;



// WEBPACK FOOTER //
// ./src/components/modals/common/ConfirmAppEnd.jsx